import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { postRegister, postLogin, postForgetPwd, getList, addData } from '../../helpers/fackBackend_Helper';

function* loginResponse({ payload: { data } }) {
  try {
    const response = yield call(postLogin, '/user_login', data);
    if (response.response.Status) {
      yield put(actions.loginSuccess(response.response.Token));
    } else {
      yield put(actions.loginFailed(response.response.Data.Message));
    }
  } catch (error) {
    yield put(actions.loginFailed(error));
  }
}

function* forgetPasswordResponse({ payload: { data } }) {
  try {
    const response = yield call(postForgetPwd, '/forgetPassword', data);
    if (response.response.Status) {
      yield put(actions.forgetPasswordSuccess(response.response.Message));
    } else {
      yield put(actions.forgetPasswordFailed(response.response.Message));
    }
  } catch (error) {
    yield put(actions.forgetPasswordFailed(error));
  }
}

function* changePasswordResponse({ payload: { data } }) {
  try {
    const response = yield call(postRegister, '/resetPassword', data);
    if (response.response.Status) {
      yield put(actions.changePasswordSuccess(response.response.Message));
    } else {
      yield put(actions.changePasswordFailed(response.response.Message));
    }
  } catch (error) {
    yield put(actions.changePasswordFailed(error));
  }
}

function* getUserDetailsResponse() {
  try {
    const response = yield call(getList, '/getUserByToken');
    if (response.response.Status) {
      yield put(actions.getUserDetailsSuccess(response.response.Message, response.response.Data));
    } else {
      yield put(actions.getUserDetailsFailed(response.response.Message));
    }
  } catch (error) {
    yield put(actions.getUserDetailsFailed(error));
  }
}

function* userDataByTokenResponse() {
  try {
    const response = yield call(getList, '/getUserByToken');
    if (response.response.Status) {
      yield put(actions.getUserDataByTokenSuccess(
        response.response.Data
      ));
    }
    else {
      yield put(actions.getUserDataByTokenError(
        response.response.Message
      ));
    }
  } catch (error) {
    yield put(actions.getUserDataByTokenError(error));
  }
}

function* logoutResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, '/user_logout', data);
    if (response.response.Status) {
      yield put(actions.logoutSuccess(response.response.Message));
    } else {
      yield put(actions.logoutFailed(response.response.Message));
    }
  } catch (error) {
    yield put(actions.logoutFailed(error.response.message ?? 'Internal Server Error'));
  }
}

function* saveFcmTokenResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, '/updateFCMToken', data);
    if (response.Status) {
      yield put(actions.saveFcmTokenSuccess(response.Message));
    } else {
      console.error("FCM token save failed");
    }
  } catch (error) {
    console.error("FCM TOKEN ERROR", error);
  }
}


export default function* rootSaga() {
  yield all([takeEvery(actions.LOGIN, loginResponse)]);
  yield all([takeEvery(actions.FORGET_PASSWORD, forgetPasswordResponse)]);
  yield all([takeEvery(actions.CHANGE_PASSWORD, changePasswordResponse)]);
  yield all([takeEvery(actions.GET_USER_DETAILS, getUserDetailsResponse)]);
  yield all([takeEvery(actions.GET_USER_DATA_BY_TOKEN, userDataByTokenResponse)]);
  yield all([takeEvery(actions.LOGOUT, logoutResponse)]);
  yield all([takeEvery(actions.SAVE_FCM_TOKEN, saveFcmTokenResponse)]);

}
